import { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../../context/CartContext";
import { ShoppingCart } from "lucide-react";
function Cart() {
  const {
    cart,
    removeFromCart,
    increaseQty,
    decreaseQty,
  } = useContext(CartContext);

  const total = cart.reduce(
    (acc, item) =>
      acc + item.price * item.quantity,
    0
  );
  const IMAGE_URL =
    process.env.NODE_ENV === "production"
      ? "https://polybionictechnologies.com"
      : "http://localhost:5001";

if (cart.length === 0) {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4">
      <div className="bg-white max-w-lg w-full rounded-3xl shadow-lg border border-gray-100 p-10 text-center">

        <div className="w-24 h-24 mx-auto mb-6 rounded-full bg-green-100 flex items-center justify-center">
          <ShoppingCart
            size={45}
            className="text-green-600"
          />
        </div>

        <h1 className="text-4xl font-bold text-gray-800 mb-3">
          Your Cart is Empty
        </h1>

        <p className="text-gray-500 text-lg mb-8">
          Looks like you haven't added any products yet.
          Start shopping and grow your hydroponic setup.
        </p>

        <Link
          to="/our-product"
          className="inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold transition-all duration-300 shadow-md hover:shadow-lg"
        >
          Continue Shopping
        </Link>

      </div>
    </div>
  );
}

  return (
    <div className="max-w-6xl mx-auto py-10 px-5">
      <h1 className="text-4xl font-bold mb-8">
        Shopping Cart
      </h1>

   {cart.map((item) => (
  <div
    key={item._id}
    className="flex items-center justify-between border-b py-5"
  >
    <div className="flex items-center gap-4">
      <img
        src={`${IMAGE_URL}/uploads/${item.image}`}
        alt={item.title}
        className="w-24 h-24 object-cover rounded-lg"
      />

      <div>
        <h3 className="font-semibold text-lg">
          {item.title}
        </h3>

        <p className="text-gray-500">
          {item.category}
        </p>

        <div className="flex items-center gap-3 mt-3">
          <button
            onClick={() =>
              decreaseQty(item._id)
            }
            className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 font-bold"
          >
            -
          </button>

          <span className="font-semibold">
            {item.quantity}
          </span>

          <button
            onClick={() =>
              increaseQty(item._id)
            }
            className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 font-bold"
          >
            +
          </button>
        </div>
      </div>
    </div>

    <div className="text-right">
      <p className="font-bold text-lg">
        ₹{item.price * item.quantity}
      </p>

      <button
        onClick={() =>
          removeFromCart(item._id)
        }
        className="text-red-500 mt-2 hover:text-red-700"
      >
        Remove
      </button>
    </div>
  </div>
))}

      {/* Total */}
      <div className="mt-8 flex justify-between items-center">
        <h2 className="text-3xl font-bold">
          Total: ₹{total}
        </h2>

        <Link
          to="/checkout"
          className="bg-green-600 hover:bg-green-700 text-white px-8 py-3 rounded-lg"
        >
          Proceed to Checkout
        </Link>
      </div>
    </div>
  );
}

export default Cart;